import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../views/SimpleButtonGroup';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

const SECTION_KEY_NAME = 'alreadyHaveEstimate';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'estimated';

export const alreadyHaveEstimateSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: 'はい' },
    { value: 'いいえ' },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '見積もりはあるか',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        すでに見積もりはお持ちですか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
